import styled from 'styled-components';
import { TextField } from '@mui/material';
export { Container, RadioGroup } from './styles';

// Estilos restritos ao requerimento: as demais abas mantêm seu layout.
export const FormContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 12px;
  font-family: Roboto, Arial, sans-serif;
  & .MuiOutlinedInput-root { border-radius: 9px; }
  @media (max-width: 600px) { padding: 4px; }
`;
export const FieldRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
`;
export const FieldGroup = styled.div`
  flex: 1;
  min-width: 230px;
  @media (max-width: 600px) { min-width: 100%; }
`;
export const FieldLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.5;
  color: #334155;
  margin-bottom: 6px;
`;
export const FieldInput = styled(TextField).attrs({ size: 'small' })`
  & .MuiOutlinedInput-root { background: #fff; }
  & .MuiOutlinedInput-root:hover { background: #f8fafc; }
`;
export const FormDivider = styled.div`height: 12px;`;
export const ButtonContainer = styled.div`
  padding: 14px;
  margin-top: 20px;
  border: 1px solid #dbe5ee;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 5px 24px rgba(15, 23, 42, 0.12);
`;
export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  & .MuiButton-root { text-transform: none; border-radius: 9px; }
  @media (max-width: 600px) {
    & .MuiButton-root { flex: 1; min-width: 120px !important; font-size: 12px; padding: 8px; }
  }
`;
